import React from 'react';
import { Link } from 'react-router-dom';
import { formatDisplayTitle } from './formatProductTitle';

/**
 * @param {{ items: Array<{ to?: string, label: string }>, align?: 'start' | 'center', className?: string }} props
 */
export default function CatalogBreadcrumb({ items, align = 'center', className = '' }) {
  if (!items?.length) return null;
  const alignClass = align === 'start' ? 'catalog-breadcrumb--start' : '';
  return (
    <nav
      aria-label="Breadcrumb"
      className={`catalog-breadcrumb ${alignClass} ${className}`.trim()}
    >
      <ol className="catalog-breadcrumb-list">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          const label = formatDisplayTitle(item.label);
          return (
            <li key={`${item.label}-${i}`} className="catalog-breadcrumb-item">
              {!last && item.to ? (
                <Link to={item.to} className="catalog-breadcrumb-link">
                  {label}
                </Link>
              ) : (
                <span className="catalog-breadcrumb-current" aria-current={last ? 'page' : undefined}>
                  {label}
                </span>
              )}
              {!last ? <span className="catalog-breadcrumb-sep" aria-hidden="true">/</span> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
